module.exports = __webpack_public_path__ + "img/featuredartist (1).390429c7.jpg";